import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import styles from './faq.module.css';
import customsPhoto from '../../assets/forFaq.jpg';

const FAQ = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    { q: t('faq1Q'), a: t('faq1A') },
    { q: t('faq2Q'), a: t('faq2A') },
    { q: t('faq3Q'), a: t('faq3A'), steps: [t('faq3Step1'), t('faq3Step2'), t('faq3Step3'), t('faq3Step4')] },
    { q: t('faq4Q'), a: t('faq4A') },
    { q: t('faq5Q'), a: t('faq5A') },
    { q: t('faq6Q'), a: t('faq6A'), steps: [t('faq6Step1'), t('faq6Step2'), t('faq6Step3'), t('faq6Step4'), t('faq6Step5'), t('faq6Step6')].filter(s => s && !s.startsWith('faq6')), closing: t('faq6Closing') },
    { q: t('faq7Q'), a: t('faq7A'), a2: t('faq7A2') },
  ];

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className={styles.faqSection} id="faq">
      <motion.h2
        className={styles.faqTitle}
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        {t('faqTitle')}
      </motion.h2>

      <div className={styles.faqBody}>
        <div className={styles.faqList}>
          {faqs.map((item, i) => (
            <motion.div
              key={i}
              className={`${styles.faqItem} ${openIndex === i ? styles.open : ''}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.4 }}
            >
              <button className={styles.faqQuestion} onClick={() => toggle(i)}>
                <span>{item.q}</span>
                <span className={`${styles.icon} ${openIndex === i ? styles.iconOpen : ''}`}>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </span>
              </button>
              <AnimatePresence initial={false}>
                {openIndex === i && (
                  <motion.div
                    className={styles.faqAnswer}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: 'easeInOut' }}
                  >
                    <p>{item.a}</p>
                    {item.a2 && <p style={{ color: '#3a5275', fontSize: '0.93rem' }}>{item.a2}</p>}
                    {item.steps && (
                      <ul style={{ listStyle: 'none', padding: '0.5rem 1.5rem 1rem', margin: 0, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        {item.steps.map((step, j) => (
                          <li key={j} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.6rem', fontSize: '0.92rem', color: '#1a3260', background: '#dde9ff', border: '1px solid rgba(71,146,244,0.30)', borderRadius: '8px', padding: '0.55rem 0.9rem' }}>
                            <span style={{ color: '#4792f4', fontWeight: 700, flexShrink: 0 }}>{j + 1}.</span>
                            {step}
                          </li>
                        ))}
                      </ul>
                    )}
                    {item.closing && (
                      <p style={{ fontSize: '0.92rem', color: '#3a5275', fontStyle: 'italic', margin: '0.25rem 0 0', paddingTop: '0.5rem', borderTop: '1px solid rgba(71,146,244,0.12)' }}>{item.closing}</p>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        <motion.div
          className={styles.faqPhotoWrap}
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <img src={customsPhoto} alt="Customs" className={styles.faqPhoto} />
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
